module.exports = __webpack_public_path__ + "img/behold-the-sonic-universe.dd2d0434.png";